const Joi = require("joi");

const commissaryAccessObjectSchema = Joi.object({
  AccessFromTime: Joi.alternatives().conditional(Joi.ref("isEnable"), {
    is: true,
    then: Joi.string().required().messages({
      "string.empty": "Please enter Access From Time.",
    }),
    otherwise: Joi.optional().strip(),
  }),

  AccessToTime: Joi.alternatives().conditional(Joi.ref("isEnable"), {
    is: true,
    then: Joi.string().required().messages({
      "string.empty": "Please enter Access To Time.",
    }),
    otherwise: Joi.optional().strip(),
  }),
}).unknown(true);

const inmateRequestForm = (data) => {
  const inmateRequestFormSchema = Joi.object({
    Type_RequestFormPermission: Joi.array().items(
      Joi.object()
        .pattern(
          /^Type_RequestFormPermission\.(\d+)\.(FacilityRequestFormTitle)$/,
          Joi.string().min(1).required().messages({
            "string.empty": "Please enter Form Title.",
            "any.required": "Please enter Form Title.",
            "string.min": "Please enter Form Title.",
          })
        )
        .unknown(true) // Allow any unknown keys within this object
    ),
  }).unknown(true); // Allow unknown keys in the root of the schema
  return inmateRequestFormSchema.validate(data, {
    abortEarly: false,
  });
};

const MGUserFormPermission = (data) => {
  const MGUserFormPermissionSchema = Joi.object({
    Type_RequestMGUserFormPermission: Joi.array().items(
      Joi.object()
        .pattern(
          /^Type_RequestMGUserFormPermission\.(\d+)\.(FacilityRequestFormTitle)$/,
          Joi.string().min(1).required().messages({
            "string.empty": "Please enter Form Title.",
            "any.required": "Please enter Form Title.",
            "string.min": "Please enter Form Title.",
          })
        )
        .unknown(true) // Allow any unknown keys within this object
    ),
  }).unknown(true); // Allow unknown keys in the root of the schema
  return MGUserFormPermissionSchema.validate(data, {
    abortEarly: false,
  });
};

const facilitySchema = Joi.object({
  //facility search

  //facility info
  FacilityCode: Joi.string()
    .trim()
    .max(10)
    .pattern(new RegExp("^[a-zA-Z0-9_]+$"))
    .required()
    .messages({
      "string.pattern.base": "Please enter Facility Code.",
      "string.empty": "Please enter Facility Code.",
      "any.required": "Please enter Facility Code.",
      "string.max": "Please enter Facility Code.",
    }),
  FacilityName: Joi.string()
    .trim()
    .pattern(new RegExp("^[a-zA-Z0-9 ]*$"))
    .required()
    .messages({
      "string.pattern.base": "Please enter Facility Name.",
      "string.empty": "	Please enter Facility Name.",
      "any.required": "	Please enter Facility Name.",
    }),
  Email: Joi.string()
    .trim()
    .email({ tlds: { allow: false } })
    .pattern(
      new RegExp(
        // /^[a-zA-Z0-9]+(?:[-_][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*\.(com|in|org|com\.in)$/
        /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/
      )
    )
    .required()
    .messages({
      "string.email": "Please enter valid E-mail.",
      "string.pattern.base": "Please enter valid E-mail.",
      "string.empty": "Please enter E-mail.",
      "any.required": "Please enter E-mail.",
    }),
  Address1: Joi.string().trim().required().messages({
    "string.pattern.base": "Please enter Address 1.",
    "string.empty": "Please enter Address 1.",
    "any.required": "Please enter Address 1.",
  }),

  City: Joi.string()
    .trim()
    .pattern(new RegExp("^[a-zA-Z]+$"))
    .allow("")
    .messages({
      "string.pattern.base": "Please enter valid City.",
    }),

  ZIP: Joi.string()
    .trim()
    .pattern(new RegExp("^[0-9]+$"))
    .allow("")
    .max(5)
    .min(5)
    .messages({
      "string.pattern.base":
        "Please enter a ZIP code that contains exactly 5 digits.",
      "string.base": " Please enter a ZIP code that contains exactly 5 digits.",
      "string.max": "Please enter a ZIP code that contains exactly 5 digits.",
      "string.min": "Please enter a ZIP code that contains exactly 5 digits.",
    }),

  StateNameID: Joi.number().min(1).required().messages({
    "number.base": "Please select State Name.",
    "any.required": "Please select State Name.",
    "number.min": "Please select  State Name.",
  }),

  PhoneNumber: Joi.string()
    .pattern(/^\(\d{3}\) \d{3}-\d{4}$/)
    .length(14)
    .required()
    .messages({
      "string.empty": "Please enter Phone Number.",
      "string.pattern.base": "Please enter valid Phone Number.",
      "string.length": "Please enter valid Phone Number.",
      "string.base": "Please enter valid Phone Number.",
    }),
  logoImage: Joi.object({
    name: Joi.string()
      .when("file", {
        is: Joi.exist(),
        then: Joi.required(),
        otherwise: Joi.optional(),
      })
      .messages({
        "string.base": "File name must be a string.",
      }),
    type: Joi.string()
      .valid("image/jpeg", "image/png", "image/jpg", "image/gif")
      .when("file", {
        is: Joi.exist(),
        then: Joi.required(),
        otherwise: Joi.optional(),
      })
      .messages({
        "string.base": "Please upload Logo.",
        "any.required": "Please upload Logo.",
        "any.only": "Please select png|jpg|jpeg|gif image.",
      }),
    size: Joi.number()
      .max(5 * 1024 * 1024)
      .when("file", {
        is: Joi.exist(),
        then: Joi.required(),
        otherwise: Joi.optional(),
      })
      .messages({
        "number.base": "Please ensure the file size is a number.",
        "number.max": "Please ensure the file size does not exceed 5 MB.",
        "any.required": "Please provide the file size.",
      }),
  }),

  //Accessible Permission
  IsMessageAcess: Joi.number().valid(1, 0).messages({
    "any.only": "Invalid access format.",
  }),
  IsMailScanningAccess: Joi.number().valid(1, 0).messages({
    "any.only": "Invalid Access format.",
  }),
  IsReview: Joi.valid(1, 0).messages({
    "any.only": "Invalid Access format.",
  }),
  IsDocumentsAccess: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  IsPhotoAccess: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  IsEcardAccess: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  IsFormReqAccess: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  IsEmojiEnabled: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  IsLawLibraryAccess: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  IsCommissaryAccess: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  IsInmateInvitePublic: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  IsInmateFreeCredit: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  DisplayCurrentDate: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  IsInmateCactasCredit: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  IsApprovalRequiredForConnectionRequest: Joi.valid(1, 0).messages({
    "any.only": "Invalid  Access format.",
  }),
  IsPurchaseDisabled: Joi.valid(1, 0).messages({
    "boolean.base": "Please ensure you have Purchase Disabled access.",
    "any.required": "Please ensure you have Purchase Disabled access.",
  }),
  InmateUploadType: Joi.string().valid(1, 2, 0).required(),

  //web service
  CactasURL: Joi.alternatives().conditional(Joi.ref("IsInmateCactasCredit"), {
    is: 1,
    then: Joi.string()
      .trim()
      // .regex(/^https?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)\/?$/)
      .regex(/^https?:\/\/([\w-]+\.)+[\w-]+\/$/)
      .required()
      .messages({
        "string.pattern.base":
          "Please enter the valid URL (ex: https://demo.cactas.com/).",
        "string.empty": "Please enter CACTAS URL.",
        "any.required": "Please enter CACTAS URL.",
        "string.uriCustomScheme":
          "Please enter the valid URL (ex: https://demo.cactas.com/).",
      }),
    otherwise: Joi.when("IsInmateCactasCredit", {
      is: 0,
      then: Joi.when("InmateUploadType", {
        is: 2,
        then: Joi.string()
          .trim()
          //.regex(/^https?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)\/?$/)
          .regex(/^https?:\/\/([\w-]+\.)+[\w-]+\/$/)
          .required()
          .messages({
            "string.pattern.base":
              "Please enter the valid URL (ex: https://demo.cactas.com/).",
            "string.empty": "Please enter CACTAS URL.",
            "any.required": "Please enter CACTAS URL.",
            "string.uriCustomScheme":
              "Please enter the valid URL (ex: https://demo.cactas.com/).",
          }),
        otherwise: Joi.optional().strip(),
      }),
      otherwise: Joi.optional().strip(),
    }),
  }),

  CactasAccessKey: Joi.alternatives().conditional(
    Joi.ref("IsInmateCactasCredit"),
    {
      is: 1,
      then: Joi.string()
        .trim()
        .pattern(new RegExp("^[a-zA-Z0-9-_]+$"))
        .required()
        .messages({
          "string.pattern.base": "Please enter valid CACTAS Access Key.",
          "string.empty": "Please enter CACTAS Access Key.",
          "any.required": "Please enter CACTAS Access Key.",
        }),
      otherwise: Joi.when("IsInmateCactasCredit", {
        is: 0,
        then: Joi.when("InmateUploadType", {
          is: 2,
          then: Joi.string()
            .trim()
            .pattern(new RegExp("^[a-zA-Z0-9-_]+$"))
            .required()
            .messages({
              "string.pattern.base": "Please enter CACTAS Access Key.",
              "string.empty": "Please enter CACTAS Access Key.",
              "any.required": "Please enter CACTAS Access Key.",
            }),
          otherwise: Joi.optional().strip(),
        }),
        otherwise: Joi.optional().strip(),
      }),
    }
  ),
  // FTP Information
  FTPServerURL: Joi.alternatives().conditional(Joi.ref("InmateUploadType"), {
    is: 1,
    then: Joi.string()
      .trim()
      .pattern(/^[0-9.]+$/) // Matches numbers and dots, assuming FTP server IP address
      .pattern(
        /\b(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/
      ) // IP address validation
      .required()
      .messages({
        "string.pattern.base":
          "URL should be in valid format (ex: 192.168.1.1).",
        "string.empty": "Please enter FTP Server URL.",
        "any.required": "Please enter FTP Server URL.",
      }),
    otherwise: Joi.optional().strip(), // Removes the field from validation if not 'ftp'
  }),

  FTPUserName: Joi.alternatives().conditional(Joi.ref("InmateUploadType"), {
    is: 1,
    then: Joi.string()
      .trim()
      .pattern(/^[a-zA-Z0-9_]+$/)
      .required()
      .messages({
        "string.pattern.base": "Please enter valid FTP Username.",
        "string.empty": "Please enter FTP Username.",
        "any.required": "Please enter FTP Username.",
      }),
    otherwise: Joi.optional().strip(), // Remove this field when InmateUploadType is not 'ftp'
  }),

  FTPPassword: Joi.alternatives().conditional(Joi.ref("InmateUploadType"), {
    is: 1,
    then: Joi.string()
      .trim()
      .pattern(new RegExp("^[a-zA-Z0-9!@#$%^&*()]+$"))
      .required()
      .messages({
        "string.pattern.base": "Please enter valid FTP Password.",
        "string.empty": "Please enter FTP Password.",
        "any.required": "Please enter FTP Password.",
      }),
    otherwise: Joi.optional().strip(), // Remove this field when InmateUploadType is not 'ftp'
  }),

  FTPFilePath: Joi.alternatives().conditional(Joi.ref("InmateUploadType"), {
    is: 1,
    then: Joi.string()
      .trim()
      .pattern(new RegExp("^/[a-zA-Z0-9/._-]+\\.(csv|txt)$"))
      .required()
      .messages({
        "string.pattern.base":
          "Please enter ftp file path with file name containing txt or csv format",
        "string.empty": "Please enter FTP File Path.",
        "any.required": "Please enter FTP File Path.",
      }),
    otherwise: Joi.optional().strip(), // Remove this field when InmateUploadType is not 'ftp'
  }),

  // Connection Request
  InmateInvitePublicFrequencyType: Joi.alternatives().conditional(
    Joi.ref("IsInmateInvitePublic"),
    {
      is: 1,
      then: Joi.number()
        .custom((value, helpers) => {
          if ([1, 2, 3].includes(value)) {
            return value;
          }
          return helpers.message("Please choose Frequency.");
        })
        .not(0)
        .required()
        .messages({
          "string.empty": "Please choose Frequency.",
          "any.required": "Please choose Frequency.",
          "any.invalid": "Please choose Frequency.",
        }),
      otherwise: Joi.optional().strip(),
    }
  ),
  InmateInvitePublicCount: Joi.alternatives().conditional(
    Joi.ref("IsInmateInvitePublic"),
    {
      is: 1,
      then: Joi.number().max(100).min(1).not(0).required().messages({
        "any.required": "Please enter Limit.",
        "any.invalid": "Please enter Limit greater than 0.",
        "number.max": "Maximum Limit 100.",
        "number.min": "Please enter Limit greater than 0.",
        "number.base": "Please enter Limit.",
        "number.unsafe": "Maximum limit 100.",
      }),
      otherwise: Joi.optional().strip(),
    }
  ),

  InmateInvitePublicRepeatLimit: Joi.alternatives().conditional(
    Joi.ref("IsInmateInvitePublic"),
    {
      is: 1,
      then: Joi.number().max(100).min(1).not(0).required().messages({
        "any.required": "Please enter Limit Per Source.",
        "any.invalid": "Please enter Limit greater than 0.",
        "number.max": "Maximum Limit 100.",
        "number.min": "Please enter Limit greater than 0.",
        "number.base": "Please enter Limit Per Source.",
        "number.unsafe": "Maximum limit 100.",
      }),
      otherwise: Joi.optional().strip(),
    }
  ),

  //Financial Setup
  FacilityMessageCost: Joi.alternatives().conditional("IsMessageAcess", {
    is: 1,
    then: Joi.number()
      .positive()
      .precision(2)
      .min(0.05)
      .max(99)
      .required()
      .messages({
        "number.base": "Please input cost of Message.",
        "number.positive": "Please enter a value between 0.05 and 99.",
        "number.precision":
          "Please enter a value with up to two decimal places.",
        "number.min": "Please enter a value between 0.05 and 99.",
        "number.max": "Please enter a value between 0.05 and 99.",
        "number.empty": "Please input cost of Message.",
        "any.required": "Please input cost of Message.",
        "number.unsafe": "Please enter a value between 0.05 and 99.",
      }),
    otherwise: Joi.optional().strip(),
  }),

  FacilityPhotoCost: Joi.alternatives().conditional(Joi.ref("IsPhotoAccess"), {
    is: 1,
    then: Joi.number()
      .positive()
      .precision(2)
      .min(0.05)
      .max(99)
      .required()
      .messages({
        "number.base": "Please input cost of Photo.",
        "number.positive": "Please enter a value between 0.05 and 99.",
        "number.precision":
          "Please enter a value with up to two decimal places.",
        "number.min": "Please enter a value between 0.05 and 99.",
        "number.max": "Please enter a value between 0.05 and 99.",
        "string.empty": "Please input cost of Photo.",
        "any.required": "Please input cost of Photo.",
        "number.unsafe": "Please enter a value between 0.05 and 99.",
      }),
    otherwise: Joi.optional().strip(),
  }),

  FacilityEcardCost: Joi.alternatives().conditional(Joi.ref("IsEcardAccess"), {
    is: 1,
    then: Joi.number()
      .positive()
      .precision(2)
      .min(0.05)
      .max(99)
      .required()
      .messages({
        "number.base": "Please input cost of E-Card.",
        "number.positive": "Please enter a value between 0.05 and 99.",
        "number.precision":
          "Please enter a value with up to two decimal places.",
        "number.min": "Please enter a value between 0.05 and 99.",
        "number.max": "Please enter a value between 0.05 and 99.",
        "string.empty": "Please input cost of E-Card.",
        "any.required": "Please input cost of E-Card.",
        "number.unsafe": "Please enter a value between 0.05 and 99.",
      }),
    otherwise: Joi.optional().strip(),
  }),

  FacilityEmojiCost: Joi.alternatives()
    .conditional("IsMessageAcess", {
      is: 1,
      then: Joi.alternatives().conditional("IsEmojiEnabled", {
        is: 1,
        then: Joi.number()
          .positive()
          .precision(2)
          .min(0.05)
          .max(99)
          .required()
          .messages({
            "number.base": "Please input cost of Emoji.",
            "number.positive": "Please enter a value between 0.05 and 99.",
            "number.precision":
              "Please enter a value with up to two decimal places.",
            "number.min": "Please enter a value between 0.05 and 99.",
            "number.max": "Please enter a value between 0.05 and 99.",
            "string.empty": "Please input cost of Emoji.",
            "any.required": "Please input cost of Emoji.",
            "number.unsafe": "Please enter a value between 0.05 and 99.",
          }),
        otherwise: Joi.optional().strip(), // Strip if IsEmojiEnabled is not 1
      }),
      otherwise: Joi.alternatives().conditional("IsPhotoAccess", {
        is: 1,
        then: Joi.alternatives().conditional("IsEmojiEnabled", {
          is: 1,
          then: Joi.number()
            .positive()
            .precision(2)
            .min(0.05)
            .max(99)
            .required()
            .messages({
              "number.base": "Please input cost of Emoji.",
              "number.positive": "Please enter a value between 0.05 and 99.",
              "number.precision":
                "Please enter a value with up to two decimal places.",
              "number.min": "Please enter a value between 0.05 and 99.",
              "number.max": "Please enter a value between 0.05 and 99.",
              "string.empty": "Please input cost of Emoji.",
              "any.required": "Please input cost of Emoji.",
              "number.unsafe": "Please enter value between 0.05 and 99.",
            }),
          otherwise: Joi.optional().strip(), // Strip if IsEmojiEnabled is not 1
        }),
        otherwise: Joi.optional().strip(), // Strip if IsPhotoAccess is not 1
      }),
    })
    .empty(""),

  //Security Setup
  IsSQ: Joi.number().valid(1, 0).messages({
    "any.only": "Please provide access to the security question.",
  }),

  IsKS: Joi.number().valid(1, 0).messages({
    "any.only": "Please enable access to the keyboard shuffle.",
  }),

  //Free Credit Setup
  InmateFreeCreditFrequencyType: Joi.alternatives().conditional(
    Joi.ref("IsInmateFreeCredit"),
    {
      is: 1,
      then: Joi.number().valid(1, 2).not(0, null).required().messages({
        "number.pattern.base": "Please choose Frequency.",
        "string.empty": "Please choose Frequency.",
        "any.required": "Please choose Frequency. ",
        "number.invalid": "Please choose Frequency. ",
        "any.invalid": "Please choose Frequency. ",
        "any.only": "Please choose Frequency. ",
      }),
      otherwise: Joi.optional().strip(),
    }
  ),

  InmateFreeCreditAmount: Joi.alternatives().conditional(
    Joi.ref("IsInmateFreeCredit"),
    {
      is: 1,
      then: Joi.number().not(0, null).required().messages({
        "string.pattern.base": "Please choose Credits.",
        "string.empty": "Please choose Credits.",
        "any.required": "Please choose Credits.",
        "number.pattern.base": "Please choose Credits.",
        "number.invalid": "Please choose Credits.",
        "any.invalid": "Please choose Credits.",
      }),
      otherwise: Joi.optional().strip(),
    }
  ),

  FreeCreditActiveStatus: Joi.number().valid(1, 0).messages({
    "string.pattern.base": "Select valid status.",
  }),

  //Allowable URL's for 'Fill all'

  LawLibraryLink: Joi.alternatives().conditional(
    Joi.ref("IsLawLibraryAccess"),
    {
      is: 1,
      then: Joi.string()
        .trim()
        .regex(/^https?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/)
        .required()
        .messages({
          "string.pattern.base": "Please enter Law Library URL.",
          "string.empty": "Please enter Law Library URL.",
          "any.required": "Please enter Law Library URL.",
          "string.uriCustomScheme": "Please enter Law Library URL.",
        }),
      otherwise: Joi.optional().strip(),
    }
  ),

  CommissaryAccessLink: Joi.alternatives().conditional(
    Joi.ref("IsCommissaryAccess"),
    {
      is: 1,
      then: Joi.string()
        .trim()
        .regex(/^https?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/)
        .required()
        .messages({
          "string.pattern.base": "Please enter Commissary URL.",
          "string.empty": "Please enter Commissary URL.",
          "string.uriCustomScheme": "Please enter Commissary URL.",
          "any.required": "Please enter valid Commissary URL.",
        }),
      otherwise: Joi.optional().strip(),
    }
  ),

  // Type_CommissaryAccessInterval: Joi.alternatives().conditional(
  //   Joi.ref("IsCommissaryAccess"),
  //   {
  //     is: 1,
  //     then: Joi.array().items(commissaryAccessObjectSchema).min(1).required(),
  //     otherwise: Joi.optional().strip(),
  //   }
  // ),

  //FORMS
  // Type_RequestFormPermission: Joi.alternatives().conditional(
  //   Joi.ref('IsFormReqAccess'),
  //   {
  //     is: 1,
  //     then: Joi.array()
  //       .items(inmateRequestFormSchema)
  //       .min(1)
  //       .required()
  //       .messages({
  //         "array.min": "Please select at least one form.",
  //         "any.required": "Forms are required when form access is enabled.",
  //       }),
  //     otherwise: Joi.optional().strip(),
  //   }
  // ),

  // Type_RequestMGUserFormPermission: Joi.alternatives().conditional(
  //   Joi.ref("IsFormReqAccess"),
  //   {
  //     is: 1,
  //     then: Joi.array()
  //       .min(1)
  //       .items(
  //         Joi.object({
  //           FacilityRequestFormTitle: Joi.string().required().messages({
  //             "any.required": "Form title is required.",
  //           }),
  //         }).unknown(true)
  //       )
  //       .min(1)
  //       .messages({
  //         "array.min": "Please Choose Atlease one form",
  //       }),
  //     otherwise: Joi.optional().strip(),
  //   }
  // ),
}).unknown(true);

const KISOKRestrict = (data) => {
  const schema = Joi.object({
    kioskRestrictIntervalFillAll: Joi.array()
      .min(1)
      .items(
        Joi.object({
          FacilityID: Joi.number().required().messages({
            "any.required": "Please enter FacilityID.",
          }),
          RandomID: Joi.string().messages({
            "any.required": "Please enter RandomID.",
          }),

          WeekDayNumber: Joi.number().required().messages({
            "any.required": " Please enter WeekDayNumber.",
          }),

          LockFromTime: Joi.string().required().messages({
            "string.pattern.base": "Select valid Free Credit amount.",
            "string.empty": "Please enter From Interval.",
            "any.required": "Please enter From Interval.",
          }),

          LockToTime: Joi.string()
            .required()
            .custom((value, helpers) => {
              const fromTime = helpers.state.ancestors[0].LockFromTime;

              if (!fromTime) {
                return helpers.message("From Time is required.");
              }

              // Parse the time strings into Date objects
              const fromDate = new Date(`1970-01-01T${fromTime}:00Z`);
              const toDate = new Date(`1970-01-01T${value}:00Z`);

              if (toDate <= fromDate) {
                return helpers.message(
                  "To Time must be greater than From Time."
                );
              }

              return value;
            })
            .messages({
              "string.empty": "Please enter To Interval.",
              "any.required": "Please enter To Interval.",
            }),

          IntervalType: Joi.string().required().messages({
            "string.pattern.base": "Select valid Free Credit amount",
            "string.empty": "Please enter Interval for.",
            "any.required": "Please enter Interval for.",
          }),

          ActiveStatus: Joi.number().required().messages({
            "any.required": "Please select ActiveStatus.",
          }),
        })
      )
      .min(1)
      .messages({
        "array.min": "The array must contain at least one object.",
      }),
  }).unknown(true);

  // Perform the base validation first
  const { error, value } = schema.validate(data, {
    abortEarly: false,
  });

  if (error) return { error };

  // Now, check for overlapping time intervals
  const intervals = value.kioskRestrictIntervalFillAll;
  for (let i = 0; i < intervals.length; i++) {
    const current = intervals[i];
    const currentLockFrom = new Date(`1970-01-01T${current.LockFromTime}:00Z`);
    const currentLockTo = new Date(`1970-01-01T${current.LockToTime}:00Z`);

    for (let j = i + 1; j < intervals.length; j++) {
      const comparison = intervals[j];
      const comparisonLockFrom = new Date(
        `1970-01-01T${comparison.LockFromTime}:00Z`
      );
      const comparisonLockTo = new Date(
        `1970-01-01T${comparison.LockToTime}:00Z`
      );

      // Check if the intervals overlap
      if (
        (currentLockFrom < comparisonLockTo &&
          currentLockTo > comparisonLockFrom) ||
        (comparisonLockFrom < currentLockTo &&
          comparisonLockTo > currentLockFrom)
      ) {
        const errorMessage = `Repeated Time Intervals.`;
        return {
          error: {
            details: [
              {
                message: errorMessage,
                path: [comparison.WeekDayNumber, j, "LockFromTime"],
              },
            ],
          },
        };
      }
    }
  }

  // If no errors, return the validated data
  return { value };
};

const CommissaryFillAll = (data) => {
  const dynamicValidationSchema = Joi.object({
    CommissaryFillAll: Joi.array().items(
      Joi.object()
        .pattern(
          /^Type_CommissaryAccessInterval\.(\d+)\.(AccessFromTime)$/, // AccessFromTime pattern
          Joi.string()
            .pattern(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "HH:MM") // Time format validation
            .when("isEnable", {
              is: true,
              then: Joi.required(),
              otherwise: Joi.optional(),
            })
            .messages({
              "string.empty": "Please enter Access From Time.",
              "any.required": "Please enter Access From Time.",
            })
        )
        .pattern(
          /^Type_CommissaryAccessInterval\.(\d+)\.(AccessToTime)$/, // AccessToTime pattern
          Joi.string()
            .pattern(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, "HH:MM") // Time format validation
            .when("isEnable", {
              is: true,
              then: Joi.required(),
              otherwise: Joi.optional(),
            })
            .custom((value, helpers) => {
              const index = helpers.state.path[1]; // Accessing index dynamically
              const WeekDayNumber = helpers.state.ancestors[0]["WeekDayNumber"];
              const accessFromTimeKey = `Type_CommissaryAccessInterval.${WeekDayNumber}.AccessFromTime`;
              const accessToTimeKey = `Type_CommissaryAccessInterval.${WeekDayNumber}.AccessToTime`;

              const AccessFromTime =
                helpers.state.ancestors[0][accessFromTimeKey];

              if (value && !AccessFromTime) {
                return helpers.error("any.invalid", {
                  message: `"Access From Time" is required before "Access To Time" at index ${index}.`,
                });
              }

              if (AccessFromTime && value) {
                const [fromHours, fromMinutes] =
                  AccessFromTime.split(":").map(Number);
                const [toHours, toMinutes] = value.split(":").map(Number);

                const fromTotalMinutes = fromHours * 60 + fromMinutes;
                const toTotalMinutes = toHours * 60 + toMinutes;

                if (toTotalMinutes <= fromTotalMinutes) {
                  return helpers.message(
                    "Please select To Time that is greater than From Time."
                  );
                }
              }
              return value; // Return the validated AccessToTime value
            })
            .messages({
              "string.empty": "Please enter Access To Time.",
              "any.required": "Please enter Access To Time.",
            })
        )
        .unknown(true) // Apply unknown(true) here, for the object inside the array
    ),
  }).unknown(true); // Apply unknown(true) here, on the outer object schema

  // Validate the entire data structure
  return dynamicValidationSchema.validate(data, {
    abortEarly: false, // Return all validation errors, not just the first one
  });
};

module.exports = {
  facilitySchema,
  inmateRequestForm,
  MGUserFormPermission,
  KISOKRestrict,
  CommissaryFillAll,
};
